import { apiConverter } from '@front/repository/Api/converter';
import { getApiClient } from '@front/repository/common/apiClient';
import type { IFeatureFlagRepository as I } from './interface';

export class FeatureFlagRepository implements I {
  get: I.Get = async ({ projectId }, options) => {
    const res = await getApiClient().POST('/feature-flag/get', {
      body: { projectId },
      signal: options?.signal,
    });
    if (!res.data) throw new Error('Failed to get feature flag');
    return apiConverter.FeatureFlag.fromApi(res.data);
  };

  update: I.Update = async ({ projectId, flags }, options) => {
    const res = await getApiClient().POST('/feature-flag/update', {
      body: { projectId, flags },
      signal: options?.signal,
    });
    if (!res.data) throw new Error('Failed to update feature flag');
    return apiConverter.FeatureFlag.fromApi(res.data);
  };
}
